import { Observable } from 'rxjs';

import { GuardShiftDetails } from '../../../../../types';
import { UnitResult } from '../../../../error';

export abstract class GetGuardShiftDetails {
    abstract execute(id: number): Observable<UnitResult<GuardShiftDetails>>;
}
